module.exports = __webpack_public_path__ + "fdda7b24c6d1d51b5bf5a234c6589c99.jpg";